import { useMemo, useContext, createContext, useCallback } from "react";
// hooks
import useStorage, { StorageKeys } from "../hooks/useStorage";
// types
import type { ReactNode } from "react";

const defaultValue = {
	expertMode: false,
	toggleExpertMode: () => {},
};

const ExpertModeContext = createContext(defaultValue);

if (process.env.NODE_ENV !== "production") {
	ExpertModeContext.displayName = "ExpertModeContext";
}

export const useExpertMode = () => (useContext(ExpertModeContext));

type Props = Readonly<{
	children: ReactNode;
}>;

export const ExpertModeProvider = ({ children }: Props) => {
	const [expertMode, setExpertMode] = useStorage(StorageKeys.expertMode);

	const handleExpertModeChanged = useCallback(() => {
		setExpertMode((prevExpertMode) => (!prevExpertMode));
	}, []);

	const value = useMemo(() => ({
		expertMode: expertMode,
		toggleExpertMode: handleExpertModeChanged,
	}), [expertMode, handleExpertModeChanged]);

	return (
		<ExpertModeContext value={value}>
			{children}
		</ExpertModeContext>
	);
};
